import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactsService } from 'app/services/contacts.service';

export interface SelectedClient {
	id: number;
	profileId?: string;
	name: string;
}

interface BlurEvent {
	target: {
		value: string;
	};
}

@Component({
	selector: 'client-search',
	templateUrl: './client-search.component.html',
	styleUrls: ['./client-search.component.scss'],
})
export class ClientSearch {
	@Input()
	noMargins = false;
	@Input()
	newStyle = false;
	@Input()
	hasError = false;
	@Output()
	public selectedClient = new EventEmitter<SelectedClient | undefined>();

	// search data
	searchResult: SelectedClient[];
	currentClient: SelectedClient;

	// Constructor.
	constructor(protected contacts: ContactsService) {}

	// Search filter.
	public searchClient(val?: any): void {
		const searchText: string = val && val.query ? val.query.trim() : '';

		if (searchText !== '') {
			this.contacts.getContacts(searchText, 20, 0, 'displayName ASC').subscribe(
				(r) => {
					this.searchResult = r.contacts.map((value) => {
						return {
							id: value.id,
							profileId: value.refUserId,
							name: value.displayName,
						};
					});
				},
				() => {
					this.searchResult = [];
				}
			);
		}
	}

	public onBlur(event: BlurEvent) {
		if (this.currentClient && event.target.value !== this.currentClient.name) {
			event.target.value = '';
			this.currentClient = null;
			this.selectedClient.emit(null);
		}
	}

	public filterSelected(val?: SelectedClient): void {
		this.currentClient = val;
		this.selectedClient.emit(val);
	}
}
